export class AdUnit {
    id: string;
    title: string;
    pageId: string;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/adunit.ts